<template>
  <div>
    <rightNav></rightNav>
    <lateralNavigation2></lateralNavigation2>
    <div class="us" >
      <div  v-html="records.detail"></div>
    </div>
  </div>

</template>

<script>
import api from "@/api";
import {listSearchMixin} from '../../config/mixin'
import rightNav from '../../components/canvasShow/rightNav'
import lateralNavigation2 from '../../components/base/lateralNavigation2'

export default {
  mixins: [listSearchMixin],
  components: {rightNav, lateralNavigation2},
  watch: {
    $route(to, from){
      console.log(to, from)
      this.type = to.query.type
      this.getRecords()
    }
  },
  data () {
	  return {
			type: '',
			records: {}
		}
	},
	created () {
		this.type = this.$route.query.type
		this.getRecords()
	},
  methods:{
		getRecords(){
			let params = {
			  url: api.records + '?type='+this.type,
			  method: 'get',
			  data: {
			  }
			}
			this.sendReq(params, (res) => {
			  if(res.success){
				  this.records = res.data
			  }
			})
		}
	}
}
</script>

<style>
	.us{
		width: 1250px;
		margin: 0 auto;
    margin-top: 50px;
	}
</style>



// WEBPACK FOOTER //
// src/views/us/about.vue